import { createNamespacedHelpers } from 'vuex';
import showToast from '@/util/toast';
import i18n from '@/locales/i18n';
import Constants from '@/constants/Constants.js';

import NotifyLayout from '@/components/shared/NotifyLayout/NotifyLayout.vue';
import MultipleLanguage from '@/components/shared/MultipleLanguage/MultipleLanguage.vue';

const authMapper = createNamespacedHelpers('global/auth');
const globalMapper = createNamespacedHelpers('global');
const modelMapper = createNamespacedHelpers('detector/model');
const imageMapper = createNamespacedHelpers('detector/image');
const trainerModelsMapper = createNamespacedHelpers('trainer/model');
const trainerImagesMapper = createNamespacedHelpers('trainer/image');

export default {
	name: 'ExpressNavBar',

	components: {
		MultipleLanguage,
		NotifyLayout,
	},

	props: {
		appName: {
			type: String,
		},

		isChangeStat: {
			type: Boolean,
		},
	},

	data() {
		return {
			languages: Constants.I18N_LANGUAGE,
			max: 1000,
			min: 100,
			isSetting: false,
			appMode: process.env.VUE_APP_MODE,
		};
	},

	computed: {
		...globalMapper.mapState(['lang', 'showDetector', 'showTrainer', 'showHistory', 'showModel']),
		...authMapper.mapState(['username', 'userInfo', 'guest']),

		TOOLTIP() {
			return {
				home: this.$t('homeTooltip'),
			};
		},
	},

	mounted() {
		i18n.locale = this.lang;
		if (this.$route.fullPath === '/toppage') this.setAllFalse();
		else if (this.$route.fullPath === '/camera') this.setIndicator('showDetector');
		else if (this.$route.fullPath === '/trainer') this.setIndicator('showTrainer');
		else if (this.$route.fullPath === '/history') this.setIndicator('showHistory');
		else if (this.$route.fullPath === '/setting') this.isSetting = true;
		else if (this.$route.fullPath === '/model') this.setIndicator('showModel');
	},
	methods: {
		...authMapper.mapActions(['logout', 'resetUserInfo']),
		...globalMapper.mapActions(['modifyLanguage', 'setAllFalse', 'setIndicator']),

		...modelMapper.mapActions(['resetModels']),
		...imageMapper.mapActions(['resetImages']),
		...trainerModelsMapper.mapActions(['resetTrainerModels']),
		...trainerImagesMapper.mapActions(['resetTrainerImages']),

		onChangeLanguage(locale) {
			this.$i18n.locale = locale;
		},

		/**
		 * Move to login screen
		 */
		onLogoutButtonClick() {
			this.isSetting = false;
			this.resetModels();
			this.resetImages();
			this.resetTrainerImages();
			this.resetTrainerModels();
			this.setAllFalse();
			this.logout();
			this.resetUserInfo();
			this.$router.push('/');
		},

		async onProfileButtonClick() {
			this.setAllFalse();
			await this.$router.push('/profile');
			this.isSetting = false;
		},

		async onSettingButtonClick() {
			this.setAllFalse();
			await this.$router.push('/setting');
			this.isSetting = true;
		},

		async onMoveDetector() {
			if (!this.username) {
				this.$router.push('');
				return;
			} else {
				let userStatus = this.userInfo.activeStatus;
				if (userStatus === 'deactivated') {
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('upgradeRequried'),
					});
					return;
				} else {
					this.setIndicator('showDetector');
					await this.$router.push('/camera');
					this.isSetting = false;
				}
			}
		},

		async onMoveToTrainer() {
			this.isSetting = false;
			if (!this.username) {
				this.$router.push('');
				return;
			} else {
				let userStatus = this.userInfo.activeStatus;
				if (userStatus === 'deactivated') {
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('upgradeRequried'),
					});
					return;
				} else {
					this.setIndicator('showTrainer');
					await this.$router.push('/trainer');
					this.isSetting = false;
				}
			}
		},

		async onMoveToHistory() {
			this.isSetting = false;
			if (!this.username) {
				this.$router.push('');
				return;
			} else {
				let userStatus = this.userInfo.activeStatus;
				if (userStatus === 'deactivated') {
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('upgradeRequried'),
					});
					return;
				} else {
					this.setIndicator('showHistory');
					await this.$router.push('/history');
					this.isSetting = false;
				}
			}
		},

		async onMoveToModel() {
			this.isSetting = false;
			if (!this.username) {
				this.$router.push('');
				return;
			} else {
				let userStatus = this.userInfo.activeStatus;
				if (userStatus === 'deactivated') {
					showToast({
						vueInstance: this,
						type: 'danger',
						message: this.$t('upgradeRequried'),
					});
					return;
				} else {
					this.setIndicator('showModel');
					await this.$router.push('/model');
					this.isSetting = false;
				}
			}
		},

		async onMoveToToppage() {
			if (!this.username) return;

			let userStatus = this.userInfo.activeStatus;
			if (userStatus === 'deactivated') {
				showToast({
					vueInstance: this,
					type: 'danger',
					message: this.$t('upgradeRequried'),
				});
				return;
			}

			await this.$router.push('/toppage');
			this.isSetting = false;
		},

		onStartTour() {
			this.$emit('onStartTour');
		},
	},
};
